export default {
  velt: {
    openPanel: 'Open comments panel',
    closePanel: 'Close comments panel',
    panel: 'Comments panel',
    tabs: 'Comments panel tabs',
    comments: 'Comments',
    settings: 'Settings & Permissions',
    dragOrTapComment: 'Drag to add comment, or tap to view comments',
    assignComment: 'Assign comment',
    markAsUnread: 'Mark as unread',
    markAsRead: 'Mark as read',
    unsubscribe: 'Unsubscribe',
    subscribe: 'Subscribe',
    deleteThread: 'Delete thread',
    editComment: 'Edit comment',
    emptyPlaceholder: 'Give feedback, ask a question or leave a note for your team members',
    searchPlaceholder: 'Search Comments',
    commentPlaceholder: 'Comment on {page}',
    replyPlaceholder: 'Reply....',
    filterPages: 'Pages',
    filterAuthor: 'Author',
    filterTagged: 'Tagged',
    statusOpen: 'Open',
    statusResolved: 'Resolved',
    anonymous: 'Anonymous',
    settingsPanel: {
      title: 'Who can comment?',
      everyoneLabel: 'Everyone',
      restrictedLabel: 'Only invited collaborators',
      emailsLabel: 'Emails',
      emailsPlaceholder: 'Type users emails separated by commas.',
    },
  },
}
